<template>
  <RecipeIndex :final-recipe="false"></RecipeIndex>
</template>

<script>
import RecipeIndex from "./RecipeIndex";
export default {
  name: "PreparationIndex",
  components: {
    RecipeIndex
  }
};
</script>

<style></style>
